var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8084 7.38863V5.41261C11.8084 3.30919 10.1047 1.60547 8.00125 1.60547C5.89783 1.60547 4.1941 3.30919 4.1941 5.41261V7.38863C3.5321 7.39612 3.0025 7.93572 3 8.59772V13.1893C3 13.8563 3.54209 14.3984 4.20909 14.3984H11.7909C12.4579 14.3984 13 13.8563 13 13.1893V8.59772C13 7.93572 12.4704 7.39612 11.8084 7.38863ZM8.00125 3.05688C9.30277 3.05938 10.357 4.11359 10.357 5.41261V7.38863H5.64552V5.41261C5.64552 4.11109 6.69973 3.05688 8.00125 3.05688ZM8.47589 10.9385V11.8703C8.47589 12.1326 8.26355 12.3449 8.00125 12.3449C7.73895 12.3449 7.52661 12.1326 7.52661 11.8703V10.9385C7.08194 10.6762 6.93455 10.1041 7.19685 9.65943C7.45916 9.21476 8.03123 9.06737 8.47589 9.32967C8.92056 9.59198 9.06795 10.164 8.80565 10.6087C8.72571 10.7436 8.61329 10.8585 8.47589 10.9385Z",
    fill: "url(#paint0_linear_5355_64962)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5355_64962",
    x1: 8,
    y1: 1.60547,
    x2: 8,
    y2: 14.3984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNock);
export default __webpack_public_path__ + "static/media/nock.c93d93c9cc02acacfef493db41b05aee.svg";
export { ForwardRef as ReactComponent };